import {
  COMMODITY_BID_URL,
  RFQ_URL,
  VERIFIED_MANUFACTURERS_URL,
  FREIGHTIQ_URL,
  CARRIER_URL,
  FREIGHTBOOKING_URL,
  ESTIMATED_CIF_URL,
  INSPECTION_URL,
  LIVE_SHIPMENT_TRACKING_URL,
  DOCUMENT_CENTER_URL,
  EXCEPTION_HUB_URL,
  BULK_CONTAINER_URL,
  FULL_CONTAINER_URL,
  SMART_CONTAINER_URL,
} from './branding';

/** Homepage solution blocks — header Solutions scroll targets. */
export const HOME_SECTION_IDS = {
  freightIq: 'freight-iq',
  smartSourcing: 'smart-sourcing',
  liveShipmentTracking: 'live-shipment-tracking',
  inspection: 'inspection-verification',
};

/** Header Solutions dropdown — grouped mega menu. */
export const SOLUTION_NAV_GROUPS = [
  {
    id: 'b2b-sourcing',
    titleKey: 'navSolutionGroupB2bSourcing',
    items: [
      {
        id: 'rfq',
        labelKey: 'navSolutionRfq',
        iconSrc: '/icons/solutions/rfq.webp',
        action: { type: 'external', href: RFQ_URL },
      },
      {
        id: 'commoditybid',
        labelKey: 'navSolutionCommodityBid',
        iconSrc: '/icons/solutions/commoditybid.webp',
        action: { type: 'external', href: COMMODITY_BID_URL },
      },
      {
        id: 'verified-manufacturers',
        labelKey: 'navSolutionVerifiedManufacturers',
        iconSrc: '/icons/solutions/verified-manufacturers.webp',
        action: { type: 'external', href: VERIFIED_MANUFACTURERS_URL },
      },
    ],
  },
  {
    id: 'digital-freight',
    titleKey: 'navSolutionGroupDigitalFreight',
    items: [
      {
        id: 'freightiq',
        labelKey: 'navSolutionFreightIq',
        iconSrc: '/icons/solutions/freightiq.webp',
        action: { type: 'external', href: FREIGHTIQ_URL },
      },
      {
        id: 'carrier-coordination',
        labelKey: 'navSolutionCarrierCoordination',
        iconSrc: '/icons/solutions/carrier-coordination.webp',
        action: { type: 'external', href: CARRIER_URL },
      },
      {
        id: 'freight-booking',
        labelKey: 'navSolutionFreightBooking',
        iconSrc: '/icons/solutions/freight-booking.webp',
        action: { type: 'external', href: FREIGHTBOOKING_URL },
      },
      {
        id: 'estimated-cif',
        labelKey: 'navSolutionEstimatedCif',
        iconSrc: '/icons/solutions/estimated-cif.webp',
        action: { type: 'external', href: ESTIMATED_CIF_URL },
      },
    ],
  },
  {
    id: 'import-control-tower',
    titleKey: 'navSolutionGroupImportControlTower',
    items: [
      {
        id: 'inspection',
        labelKey: 'navSolutionInspection',
        iconSrc: '/icons/solutions/inspection.webp',
        action: { type: 'external', href: INSPECTION_URL },
      },
      {
        id: 'live-shipment-tracking',
        labelKey: 'navSolutionShipmentTracking',
        iconSrc: '/icons/solutions/live-shipment-tracking.webp',
        action: { type: 'external', href: LIVE_SHIPMENT_TRACKING_URL },
      },
      {
        id: 'document-center',
        labelKey: 'navSolutionDocumentCenter',
        iconSrc: '/icons/solutions/document-center.webp',
        action: { type: 'external', href: DOCUMENT_CENTER_URL },
      },
      {
        id: 'exception-hub',
        labelKey: 'navSolutionExceptionHub',
        iconSrc: '/icons/solutions/exception-hub.webp',
        action: { type: 'external', href: EXCEPTION_HUB_URL },
      },
    ],
  },
];

/** Header Procurement Models dropdown — flat menu. */
export const PROCUREMENT_MODEL_NAV_ITEMS = [
  {
    id: 'full-container',
    labelKey: 'navSolutionFullContainer',
    iconSrc: '/icons/solutions/full-container.webp',
    action: { type: 'external', href: FULL_CONTAINER_URL },
  },
  {
    id: 'smart-container',
    labelKey: 'navSolutionSmartContainer',
    iconSrc: '/icons/solutions/smart-container.webp',
    action: { type: 'external', href: SMART_CONTAINER_URL },
  },
  {
    id: 'bulk-container',
    labelKey: 'navSolutionBulkContainer',
    iconSrc: '/icons/solutions/bulk-container.webp',
    action: { type: 'external', href: BULK_CONTAINER_URL },
  },
];

/** Flat list — mobile / legacy consumers. */
export const SOLUTION_NAV_ITEMS = SOLUTION_NAV_GROUPS.flatMap((group) => group.items);
